import React from 'react';
import PropTypes from 'prop-types';

import CategoryViewPage from './CategoryViewPage.js';

// Sous-modèle "categoryPack": réutilise entièrement la page catégorie, en ne listant
// que les packs (voir CategoryPackViewPageModel.js).
function CategoryPackViewPage({ page }) {
	return <CategoryViewPage page={page} onlyPacks />;
}

CategoryPackViewPage.propTypes = {
	page: PropTypes.object.isRequired,
};

export default CategoryPackViewPage;
